var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.app.loading)?_c('div',{staticClass:"linear-activity"},[_c('div',{class:_vm.type,style:({ width: _vm.width })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }